import { render, staticRenderFns } from "./CustomFieldValue.vue?vue&type=template&id=77ea1e8d&scoped=true&"
import script from "./CustomFieldValue.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomFieldValue.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea1e8d",
  null
  
)

export default component.exports